import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Topic } from '../../models/core/topic';

@Injectable({
  providedIn: 'root',
})
export class MessageBus {
  topics = new Map<Topic, Subject<any>>();

  public publish(topic: Topic, value: any = null): void {
    this.createTopic(topic);
    this.topics.get(topic).next(value);
  }

  public topic(topic: Topic): Observable<any> {
    this.createTopic(topic);
    return this.topics.get(topic).asObservable();
  }

  private createTopic(topic: Topic) {
    if (!this.topics.has(topic)) {
      this.topics.set(topic, new Subject<any>());
    }
  }
}
